module.exports = __webpack_public_path__ + "static/media/icofirmaya_driver.6a8f38b3.svg";